"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=sqs-config.js.map